<div class="home-title bg-light text-center py-6">
  <h4 class="m-0 text-bold">Bem-vindo(a) ao PGP, {{ primeiroNome }}</h4>
</div>

<div class="home-container">
  <div class="row">
    <div class="col-12 col-lg-8 mb-4 mb-lg-0">
      @if (allMenuItems.length > 0) {
        <div class="menu-grid">
          @for (item of allMenuItems; track item.label) {
            <a
              class="menu-card"
              href="javascript:void(0)"
              [ngClass]="{'disabled': item.disabled}"
              (click)="navegarPara(item)"
              [attr.title]="getCardLabel(item)"
            >
              <div class="menu-card-icon">
                @if (item.icon) {
                  <i class="fas" [ngClass]="item.icon" aria-hidden="true"></i>
                } @else {
                  <i class="fas fa-file-alt" aria-hidden="true"></i>
                }
              </div>
              <span class="menu-card-label">{{ getCardLabel(item) }}</span>
            </a>
          }
        </div>
      } @else {
        <div class="empty-menu">
          <i class="fas fa-exclamation-circle fa-3x mb-3" aria-hidden="true"></i>
          <p>Nenhuma funcionalidade disponível para o seu perfil.</p>
          <p class="text-muted">Entre em contato com o administrador do sistema.</p>
        </div>
      }
    </div>

    <div class="col-12 col-lg-4">
      <div class="info-card">
        <h5 class="info-title">
          <i class="fas fa-info-circle" aria-hidden="true"></i>
          Sobre o PGP
        </h5>
        <p class="info-text">
          O PGP é a Plataforma de Gerenciamento de Programas de Provimento do Ministério da Saúde,
          desenvolvida para o provimento de profissionais para o SUS. A plataforma tem como objetivo
          organizar, automatizar e conferir transparência aos processos de inscrição, alocação,
          acompanhamento e gestão de profissionais em iniciativas como o Programa Mais Médicos.
        </p>
      </div>
    </div>
  </div>
</div>
